import { memo } from 'react';

import { FileStatusIconErrored, FileStatusSubtitle, FileStatusTitle } from '@air/feature-file-status/ui';

import { type AssetBoardMembershipUpdateOperation } from '~/components/AssetBoardMembershipUpdateTasks/assetBoardMembershipUpdateTaskPanelTypes';
import { getTaskPaneFileStatusIconSize } from '~/components/FileStatusTrackingPane/getTaskPaneFileStatusIconSize';
import { PaneItemTW } from '~/components/FileStatusTrackingPane/PaneItemTW';
import { TaskPaneDismissButton } from '~/components/FileStatusTrackingPane/TaskPaneDismissButton';
import { useTemporaryFeatureFlags } from '~/hooks/useTemporaryFeatureFlags';

export type AssetBoardMembershipUpdateTaskFailedPanelItemProps = {
  onClear: () => void;
  operation: AssetBoardMembershipUpdateOperation;
};

export const AssetBoardMembershipUpdateTaskFailedPanelItem = memo(
  ({ onClear, operation }: AssetBoardMembershipUpdateTaskFailedPanelItemProps) => {
    const { ui2026 } = useTemporaryFeatureFlags();
    const isAdd = operation === 'add';
    const failedTitle = isAdd ? 'Failed to add assets' : 'Failed to move assets';
    const ui2026FailedTitle = isAdd ? 'Couldn’t add assets' : 'Couldn’t move assets';

    return (
      <PaneItemTW
        avatar={<FileStatusIconErrored size={getTaskPaneFileStatusIconSize(ui2026)} />}
        title={
          <FileStatusTitle data-testid="ASSET_BOARD_MEMBERSHIP_UPDATE_TASK_FAILED_TITLE">
            {ui2026 ? ui2026FailedTitle : failedTitle}
          </FileStatusTitle>
        }
        subtitle={ui2026 ? undefined : <FileStatusSubtitle>Please try again.</FileStatusSubtitle>}
        buttons={<TaskPaneDismissButton label="Clear" onClick={onClear} />}
      />
    );
  },
);

AssetBoardMembershipUpdateTaskFailedPanelItem.displayName = 'AssetBoardMembershipUpdateTaskFailedPanelItem';
